import React from 'react'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import { statusBadgeSx } from '../../common/sharedStyles'
import { healthMeta } from './alertUtils'

/** Palette-consistent badge for an AlertHealth state; hover explains the rule. `reason` (optional) is appended to the tooltip. */
export default function HealthBadge({ state, reason, sx }) {
  const m = healthMeta(state)
  const tip = reason ? `${m.help}\n\n${reason}` : m.help
  return (
    <Tooltip title={<Box component='span' sx={{ whiteSpace: 'pre-line' }}>{tip}</Box>} arrow>
      <Box component='span' sx={{ ...statusBadgeSx(m.tone), whiteSpace: 'nowrap', ...sx }}>{m.label}</Box>
    </Tooltip>
  )
}

/** Same look for a message's delivery outcome ({ label, tone } from alertUtils.deliveryOf). */
export function OutcomeBadge({ outcome, title }) {
  const chip = <Box component='span' sx={{ ...statusBadgeSx(outcome.tone), whiteSpace: 'nowrap' }}>{outcome.label}</Box>
  return title ? <Tooltip title={title} arrow>{chip}</Tooltip> : chip
}
